import { axiosClient } from "clients/axios";

import type {
  UserCreateParams,
  UserUpdateParams,
  UserUpdateResponse,
  UserCreateResponse,
  UserNotificationUpdateParams,
  UserDeleteResponse,
} from "types/api";

// Patch Client record
export const updateUser = async (
  organizationId: string,
  userId: string,
  values: UserNotificationUpdateParams | UserUpdateParams
) => {
  const response = await axiosClient.patch<UserUpdateResponse>(
    `organization/${organizationId}/user/${userId}`,
    values
  );

  return response.data;
};

// Add Client record
export const createUser = async (
  organizationId: string,
  values: UserCreateParams
) => {
  const response = await axiosClient.post<UserCreateResponse>(
    `organization/${organizationId}/user`,
    values
  );

  return response.data;
};

export const archiveOrganizationUser = async (
  organizationId: string,
  userId: string
) => {
  const response = await axiosClient.post<UserDeleteResponse>(
    `organization/${organizationId}/user/${userId}`
  );

  return response.data;
};

export const addAuditorUserToOrg = async (
  organizationId: string,
  userId: string
) => {
  const response = await axiosClient.patch<UserUpdateResponse>(
    `organization/${organizationId}/user/${userId}/auditor`
  );

  return response.data;
};

export const removeAuditorUserFromOrg = async (
  organizationId: string,
  userId: string
) => {
  const response = await axiosClient.delete<UserUpdateResponse>(
    `organization/${organizationId}/user/${userId}/auditor`
  );

  return response.data;
};

export const addEnterpriseUserToOrg = async (
  organizationId: string,
  userId: string
) => {
  const response = await axiosClient.patch<UserUpdateResponse>(
    `organization/${organizationId}/user/${userId}/enterprise`
  );

  return response.data;
};

export const sendUserSetupInvitation = async (
  organizationId: string,
  userId: string
) => {
  const response = await axiosClient.post<UserUpdateResponse>(
    `organization/${organizationId}/user/${userId}/invite`
  );

  return response.data;
};

export const removeEntAdminFromOrg = async (
  organizationId: string,
  userId: string
) => {
  const response = await axiosClient.post<UserUpdateResponse>(
    `organization/${organizationId}/user/${userId}/enterprise/remove`
  );

  return response.data;
};
